import { render, staticRenderFns } from "./paypal-buttons.vue?vue&type=template&id=6cd77f95&scoped=true&"
import script from "./paypal-buttons.vue?vue&type=script&lang=js&"
export * from "./paypal-buttons.vue?vue&type=script&lang=js&"
import style0 from "./paypal-buttons.vue?vue&type=style&index=0&id=6cd77f95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd77f95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VOverlay})
